import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  filtersContainer: {
    marginBottom: theme.spacing(3),
  },
  fullWidth: {
    width: '100%',
    '& .MuiSelect-root': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiListItemText-root': {
      margin: 0,
    },
  },
  templateCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[4],
    },
  },
  selectedCard: {
    border: `2px solid ${theme.palette.secondary.main}`,
    backgroundColor: theme.palette.action.selected,
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
  },
  cardTitle: {
    fontWeight: 'bold',
  },
  criticalityIcon: {
    marginLeft: theme.spacing(1),
  },
  tagsContainer: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  selectedSummary: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    marginBottom: theme.spacing(3),
    border: `1px solid ${theme.palette.divider}`,
  },
  description: {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginBottom: theme.spacing(2),
    '-webkit-line-clamp': 4,
    '-webkit-box-orient': 'vertical',
  },
  tooltipDescription: {
    fontSize: 'inherit !important',
    '& *': {
      fontSize: 'inherit !important',
      fontFamily: 'inherit !important',
      lineHeight: 'inherit !important',
      margin: '0 !important',
      fontWeight: 'inherit',
    },
  },
  htmlTooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 400,
    maxHeight: '50vh',
    overflowY: 'auto',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

export default useStyles;
